import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Button, Space, Typography } from "antd";
import TextArea from "antd/lib/input/TextArea";

interface CommentResponseInputProps {
  onSubmit: (note: string) => Promise<void>;
  submitting: boolean;
  error: string | null;
}
export interface CommentResponseInputHandle {
  prefill: (text: string) => void;
}

export const CommentResponseInput = forwardRef<
  CommentResponseInputHandle,
  CommentResponseInputProps
>(({ onSubmit, submitting, error }, ref) => {
  const [text, setText] = useState("");
  const [focused, setFocused] = useState(false);

  const textAreaRef = useRef<any>(null);

  useImperativeHandle(ref, () => ({
    prefill(value: string) {
      setText((prev) => {
        if (prev.includes(value)) return prev;
        return prev.trim() ? `${prev}\n${value}` : value;
      });
      setFocused(true);
      setTimeout(
        () => textAreaRef.current?.focus({ preventScroll: true }),
        0,
      );
    },
  }));

  const showActions = focused || !!text.trim();

  const handleSubmit = async () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    await onSubmit(trimmed);
    setText("");
    setFocused(false);
  };

  const handleCancel = () => {
    setText("");
    setFocused(false);
  };

  return (
    <div>
      <TextArea
        ref={textAreaRef}
        rows={3}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onFocus={() => setFocused(true)}
        disabled={submitting}
        placeholder="Add a comment..."
      />
      {error && (
        <Typography.Text
          type="danger"
          style={{ display: "block", marginTop: 4 }}
        >
          {error}
        </Typography.Text>
      )}
      {showActions && (
        <Space style={{ marginTop: 8 }}>
          <Button
            type="primary"
            loading={submitting}
            disabled={!text.trim() || submitting}
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Button disabled={submitting} onClick={handleCancel}>
            Cancel
          </Button>
        </Space>
      )}
    </div>
  );
});
